<span
  (click)="star_click()"
  [title]="'remove from your list'"
  [hidden]="!selected"
>
  <app-icon
    [type]="IconType.Favorite"
    [class]="'medium'"
  ></app-icon>
</span>
<span (click)="star_click()" [title]="'add to your list'" [hidden]="selected">
  <app-icon
    [type]="IconType.Favorite_unchecked"
    [class]="'medium'"
  ></app-icon>
</span>
